const NotificationModel = {
    data() {
        return {
            NotificationModel: {
                getNotifications: () =>
                    this.$http.post("v2/notifications").then(
                        (r) => r.data,
                        (e) => Promise.reject(e.data)
                    ),
                markAsReadNotification: (payload) =>
                    this.$http
                        .post("v2/notifications/mark-as-read", payload)
                        .then(
                            (r) => r.data,
                            (e) => Promise.reject(e.data)
                        ),
                markAllNotificationsAsRead: () =>
                    this.$http
                        .post("v2/notifications/mark-all-as-read")
                        .then(
                            (r) => r.data,
                            (e) => Promise.reject(e.data)
                        ),
            },
        }
    },
}

export default NotificationModel
